import "./index.css";
import API from "src/API2";
import toast from "react-hot-toast";

const ToggleButton = ({ state, onChange, setVal, id }) => {
  const handleToggle = async () => {
    const newState = !state;

    // If used in a form (create/update), just toggle locally
    if (setVal) {
      setVal(newState);
      return;
    }

    // If used in list with API call
    if (onChange && id) {
      try {
        onChange(newState);
        await API.put(`rooms/avai/${id}`, { available: newState });
        toast.success("Availability changed successfully");
      } catch (error) {
        onChange(state);
        toast.error("Failed to change availability");
        console.error("Toggle update error:", error);
      }
    }
  };

  return (
    <div
      className={state ? "ToggleButton active" : "ToggleButton"}
      onClick={handleToggle}
    >
      <div className={state ? "circle active" : "circle"}></div>
    </div>
  );
};

export default ToggleButton;
